<nav aria-label="Main, mobile">
  @for (item of items(); track item.label) {
    @if (item.route) {
      <!--
        `exact` only for /v2 itself, or the estimator tab stays lit on every
        child route -- routerLinkActive matches on prefix.
      -->
      <a
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: item.route === '/' }">
        <ng-icon [name]="item.icon" />
        <span>{{ item.label }}</span>
      </a>
    } @else {
      <!--
        No target here on purpose. On a phone a new tab is a tab nobody comes
        back from, and the fourth slot is a `tel:` for a client -- handing
        that to a new tab opens a blank one.
      -->
      <a [href]="item.href">
        <ng-icon [name]="item.icon" />
        <span>{{ item.label }}</span>
      </a>
    }
  }
</nav>
